<template>
  <header id="page-header">
      <div class="content-header">
          <div class="content-header-section">
              <button type="button" class="btn btn-circle btn-dual-secondary" @click="sidebar_toggle()">
                  <i class="fa fa-navicon"></i>
              </button>
          </div>
          <div class="content-header-section">
              <div class="btn-group" role="group">
                  <button type="button" class="btn btn-rounded btn-dual-secondary" id="page-header-user-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-user d-sm-none"></i>
                      <span class="d-none d-sm-inline-block">{{authUser ? authUser.fullname : ''}}</span>
                      <i class="fa fa-angle-down ml-5"></i>
                  </button>
                  <div class="dropdown-menu dropdown-menu-right min-width-200" aria-labelledby="page-header-user-dropdown">
                      <h5 class="h6 text-center py-10 mb-5 border-b text-uppercase">{{authUser ? authUser.firstname : ''}}</h5>
                      <a class="dropdown-item" href="#" @click.prevent="logout">
                          <i class="si si-logout mr-5"></i> {{ $t('app.logout') }}
                      </a>
                  </div>
              </div>
          </div>
      </div>
      <div id="page-header-loader" class="overlay-header bg-primary">
          <div class="content-header content-header-fullrow text-center">
              <div class="content-header-item">
                  <i class="fa fa-sun-o fa-spin text-white"></i>
              </div>
          </div>
      </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'authUser',
    ]),
  },
  mounted() {
    window.jQuery('#page-container').addClass('sidebar-o');
  },
  methods: {
    ...mapActions([
      'LOGOUT',
    ]),
    logout() {
      this.LOGOUT()
        .then(() => {
          this.$router.push('/login');
        });
    },
  },
};
</script>
